// extracted by mini-css-extract-plugin
export default {"chats":"chats_chats__RWaMB","list":"chats_list__PiVwy","name":"chats_name__jWl-R"};